import React from "react";
import CtaSection from "../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import Whychooseus from "../Components/internal-pages/WhyChooseus";
import { Helmet } from "react-helmet";

const BrandedMerchandise = () => {
  const CTAContent = [
    {
      pageName: "Branded Merchandise",
      paragraphitalic: "Turn Moments into Memories with Branded Merchandise",
      paragraphText:
        "At eYantra, we specialize in creating impactful branded merchandise solutions that go beyond the ordinary. Whether you’re looking to engage employees, impress clients, or uplift your events, our expertise in corporate gifting, employee gifts, event gifts, and experiential gifting makes sure every experience is memorable and meaningful.",
      ContactFormName: "Branded Merchandise",
    },
  ];

  const ContentImg = [
    {
      index: 0,
      leftImg: "./assests/images/internalpages/business-gift-box.jpg",
      leftHeading: "Corporate Gifting",
      leftSmallpara: "Build Stronger Business Relationships",
      leftParagraph:
        "Delight clients, partners, and prospects with thoughtfully curated corporate gifts that leave a lasting impression. From premium hampers to personalized gifts, our solutions are designed to resonate with your audience and showcase your brand values.",
      leftRedirectUrl: "/branded-merchandise/corporate-gifting",
    },
    {
      index: 1,
      leftImg: "./assests/images/internalpages/Group 47.png",
      leftHeading: "Event Gifts",
      leftSmallpara: "Build Stronger Business Relationships",
      leftParagraph:
        "Delight clients, partners, and prospects with thoughtfully curated corporate gifts that leave a lasting impression. From premium hampers to personalized gifts, our solutions are designed to resonate with your audience and showcase your brand values.",
      leftRedirectUrl: "/branded-merchandise/event-gifts",
    },
  ];

  const rightImgContent = [
    {
      index: 0,
      rightImg: "./assests/images/internalpages/Group 45.png",
      rightHeading: "Employee Gifts",
      rightSmallpara: "Celebrate Your Workforce ",
      rightParagraph:
        "Reward and motivate your employees with branded merchandise that acknowledges their contributions and strengthens company culture. From onboarding kits to festive gifts, we have options for every occasion. ",
      rightRedirectUrl: "/branded-merchandise/employee-gifts",
    },
  ];

  const NoGapContent = [
    {
      NogaprightImg: "./assests/images/internalpages/7289 1.png",
      NogaprightHeading: "Experiential Gifting",
      NogaprightSmallpara: "Go Beyond the Gift",
      NogaprightParagraph: "Turn gifting into an experience with custom gifting that evoke emotions and strengthen brand connections. Perfect for influencers, tastemakers, and premium client engagement.",
      NogaprightRedirectUrl: "/branded-merchandise/experiential-gifting",
    },
  ];

  return (
    <>
    <Helmet>
      <title>Festive & Corporate Gifting by eYantra</title>
      <meta name="description" content="Discover festive gifting, employee joining kits, and personalised business items with eYantra’s branded merchandise and corporate gifting solutions."/>
      <meta name="keywords" content="eyantra, festive gifting, branded merchandise, corporate gifting, employee joining kits, employee gifts, personalised business items"/>

    </Helmet>
      <div className="p-0 m-2">
        <CtaSection data={CTAContent} />

        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        <LeftImgrightContent leftImgContent={ContentImg[1]} />

        <NogapRightImage data={NoGapContent[0]} />

        <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
      </div>
    </>
  );
};

export default BrandedMerchandise;
